<template>
	<div id="app" class="bgZoom">
		<router-view></router-view>
		<router-view name="home"></router-view>
	</div>
</template>

<script>
export default{
  created () {
    if (process.env.ENV_CONFIG == 'sit')document.title = '校园安全大数据平台'
    // else document.title = '西南大学校园一体化平台'
    else document.title = '西南大学安全管理智慧平台'
  },
  methods: {

  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/App.vue